import React from 'react';
import { ZdsInputDate } from '@zig-design-system/ui-components-react';
import { Label } from './elements/Label';
import Translation from '../../../Shared/components/Translation';
export const Date = ({ field, onChange, value }) => {
    const handleChange = (e) => {
        onChange(field, e.target.value);
    };
    return (React.createElement(ZdsInputDate, { id: `powermail_field_${field.marker}`, disabled: field.disabled, readonly: field.readonly, required: field.mandatory, mindate: field.minDate, maxdate: field.maxDate, disableWeekends: field.weekdaysOnly, disabledDates: field.disabledDates, calendar: field.hideDatepicker ? 'off' : 'on-focus', class: "powermail-date", onZdsChange: handleChange, value: value },
        React.createElement(Label, { field: field }),
        React.createElement("span", { slot: "validation-message", "data-reason": "badInputInvalid" },
            React.createElement(Translation, { item: "powermail.error.invalidDate" })),
        React.createElement("span", { slot: "validation-message", "data-reason": "rangeUnderflow" },
            React.createElement(Translation, { item: "powermail.error.dateTooEarly" }),
            " ",
            field.minDate),
        React.createElement("span", { slot: "validation-message", "data-reason": "rangeOverflow" },
            React.createElement(Translation, { item: "powermail.error.dateTooLate" }),
            " ",
            field.maxDate),
        React.createElement("span", { slot: "validation-message", "data-reason": "badInputDisabled" },
            React.createElement(Translation, { item: "powermail.error.dateDisabled" })),
        React.createElement("span", { slot: "validation-message", "data-reason": "badInputHoliday" },
            React.createElement(Translation, { item: "powermail.error.dateIsHoliday" })),
        React.createElement("span", { slot: "validation-message", "data-reason": "badInputWeekend" },
            React.createElement(Translation, { item: "powermail.error.dateIsWeekend" }))));
};
